module.exports = __webpack_public_path__ + "static/img/社保@2x.699df02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/社保@2x.png
// module id = 9T42
// module chunks = 32